<template>
  <!-- <base-card>gdkjfoihtraphndfmbPFKN -->
  <div class="uplodeImages">
    <div class="chooseImages" v-if="images.length <= lengthNumber">
      <div class="placholder">
        <span>أضف صورة</span>
        <div class="icons">
          <i class="fas fa-camera-alt"></i>
        </div>
      </div>
      <input
        ref="uplode_file"
        class="file_input"
        type="file"
        accept="image/*"
        name="imageToUplode"
        @change="chooseImages"
        v-if="imagesToUplode.length <= 3"
      />
      <div class="overlay">
        <div class="icons">
          <i class="fas fa-camera-alt"></i>
          <!-- <i class="fas fa-camera-alt"></i>
            <i class="fas fa-camera-alt"></i> -->
        </div>
      </div>
    </div>
    <div class="showImages">
      <transition name="fadeInUp" mode="out-in">
        <div
          class="images b-flex justify-content-center"
          v-if="images.length > 0 && images[0]"
        >
          <div class="image" v-for="(img, index) in images" :key="index">
            <template v-if="img">
              <span class="close" @click="deleteImage(img, index)"
                ><i class="fas fa-times-circle"></i
              ></span>
              <img :src="img.media" />
            </template>
          </div>
        </div>
      </transition>
    </div>
  </div>
  <!-- </base-card> -->
</template>

<script>
export default {
  emits: ["inputChanged"],

  props: {
    data_src: {
      default: () => [],
      required: false,
      type: Array,
    },
    lengthNumber: {
      default: 2,
      required: false,
      type: Number,
    },
    category: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      imagesToUplode: [],
      DataSourse: this.data_src,
    };
  },

  computed: {
    images() {
      // if (!this.DataSourse.length) {
      //   return [...this.imagesToUplode];
      // } else if (!this.imagesToUplode.length) {
      //   return [...this.imagesToUplode, ...this.DataSourse];
      // } else {
      //   }
      return [...this.imagesToUplode, ...this.DataSourse];
    },
  },

  methods: {
    chooseImages(e) {
      let images = Array.from(e.target.files);
      images.forEach((img) => {
        console.log("img", img);
        if (img.name) {
          let src = URL.createObjectURL(img);
          this.imagesToUplode.push({
            img_file: img,
            media: src,
            name: img.name,
            uniqeID: Math.random().toString(16).slice(2),
            first: true,
          });
          this.helper_containsObject(img, this.imagesToUplode, "name");
        }

        e.target.value = null;
      });

      this.$emit("inputChanged", this.images);
      this.imagesToUplode.forEach((item, index) => {
        this.imagesToUplode[index].first = false;
      });
    },

    deleteImage(img) {
      if (img.id) {
        this.axios
          .delete(`project/app_media/${img.id}`)
          .then(() => {
            this.$iziToast.success({
              timeout: 2000,
              message: this.$t("deleteSuccess"),
              position: "bottomRight",
            });
            console.log(this.images);
            // this.DataSourse.splice(index, 1);
            this.DataSourse = this.DataSourse.filter((image) => {
              return img.id != image.id;
            });
          })
          .catch(() => {});
      } else {
        this.imagesToUplode = this.imagesToUplode.filter((image) => {
          return img.media != image.media;
        });
        this.$emit("inputChanged", this.images);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.uplodeImages {
  margin-bottom: 15px;
  .chooseImages {
    position: relative;
    text-align: center;
    cursor: pointer;
    margin: 10px auto;
    width: 300px;

    &:hover {
      .overlay {
        opacity: 1;

        .icons {
          i {
            transform: scale(5);
          }
        }
      }
    }

    img {
      position: relative;
      top: 0;
      left: 0;
      z-index: 0;
      max-width: 100%;
      height: 150px;
      padding: 6px 0;
      display: inline-block;
      font-size: 15px;
      text-transform: uppercase;
      cursor: pointer;
      border-radius: 20px;
    }

    .placholder {
      position: relative;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 150px;
      padding: 6px 0;
      display: inline-block;
      font-size: 15px;
      text-transform: uppercase;
      border-radius: 20px;
      background: #333;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      span {
        color: #eee;
        display: block;
      }

      .icons {
        display: flex;
        justify-content: space-between;

        i {
          display: block;
          margin-inline: 5px;
        }
      }
    }

    .file_input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: inline-block;
      opacity: 0;
      cursor: pointer;
    }
    .overlay {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;

      transition: all 0.2s linear;
      opacity: 0;

      .icons {
        display: flex;

        i {
          display: block;
          margin-inline: 35px;
          color: #eee;
          font-size: 15px;
          transition: all 0.2s linear;
          transform: scale(0);
        }
      }
    }
  }

  .showImages {
    .images {
      display: flex;
      align-items: center;
      max-width: inherit;
      overflow-x: scroll;

      .image {
        position: relative;

        .close {
          background: #fff;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          position: absolute;
          top: 12px;
          right: 13px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          i {
            color: crimson;
          }
        }

        img {
          margin: 10px;
          width: 150px;
          height: 150px;
          object-fit: cover;
          border-radius: 25px 0 25px 0;
        }
      }
    }
  }
}
</style>
